<template>
  <div class="nav">
    <div class="navBar">
      <div @click="leftClick()">
        <img src="../assets/ic_left.png" alt=""  />
      </div>
      <p>{{ msg }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "NavBar",
  props: {
    msg: String,
  },
  methods: {
    leftClick() {
    //   console.log(11);
        this.$router.back(-1)
    },
  },
};
</script>

<style lang="less" scoped>
.nav{
    position: fixed;
    top: 0;
    width: 100%;
    background: #fff;
    z-index: 1000;
}
.navBar {
  height: 0.88rem;

  display: flex;
  align-items: center;
  position: relative;
  div{
      width: 1rem;
      height: 0.88rem;
      z-index: 1000;
  }
  img {
    width: 0.44rem;
    height: 0.44rem;
    padding: 0.22rem 0.3rem;
  }
  p {
    position: absolute;
    width: 100%;
    text-align: center;
    color: #333;
    font-size: 0.32rem;
    font-weight: 400;
  }
}
</style>